import { Star } from "lucide-react";

const COPY = {
  ru: {
    eyebrow: "Нам важно ваше мнение",
    title: "Понравился сервис? Оставьте отзыв в Google",
    text: "Ваш отзыв помогает другим найти нас и поддерживает нашу команду флористов. Это займёт меньше минуты.",
    button: "Оставить отзыв в Google",
  },
  en: {
    eyebrow: "Your opinion matters",
    title: "Enjoyed our service? Leave a Google review",
    text: "Your review helps others find us and supports our florist team. It takes less than a minute.",
    button: "Leave a Google review",
  },
  tr: {
    eyebrow: "Görüşünüz bizim için önemli",
    title: "Hizmetimizi beğendiniz mi? Google'da yorum bırakın",
    text: "Yorumunuz başkalarının bizi bulmasına yardımcı olur ve çiçekçi ekibimize destek olur. Bir dakikadan az sürer.",
    button: "Google'da yorum bırak",
  },
};

export const GoogleReviewCta = ({ url, lang = "ru" }) => {
  if (!url) return null;
  const c = COPY[lang] || COPY.ru;

  return (
    <section className="py-12 sm:py-16 bg-white" data-testid="google-review-cta">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="relative overflow-hidden rounded-3xl border border-pink-100 bg-gradient-to-br from-pink-50 via-white to-rose-50 p-8 sm:p-10 text-center">
          <div className="flex justify-center gap-1 mb-4" aria-hidden="true">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="w-6 h-6 fill-amber-400 text-amber-400" />
            ))}
          </div>
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-pink-500 mb-2">
            {c.eyebrow}
          </p>
          <h2
            className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            {c.title}
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-xl mx-auto mb-7">
            {c.text}
          </p>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-review-link"
            className="inline-flex items-center gap-2 rounded-full bg-gray-900 px-7 py-3.5 text-sm sm:text-base font-semibold text-white shadow-lg hover:bg-gray-800 hover:shadow-xl hover:-translate-y-0.5 transition-all"
          >
            <svg className="w-5 h-5" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
              <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
              <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
              <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
            </svg>
            {c.button}
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewCta;
